import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarComponent } from './progress-bar.component';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { IconModule } from '../icon/icon-module';

@NgModule({
  declarations: [ProgressBarComponent],
  imports: [CommonModule, PipesModule, IconModule],
  exports: [ProgressBarComponent],
})
export class ProgressBarModule {}
